import { render, staticRenderFns } from "./tutarbilgileri.vue?vue&type=template&id=38d0b2d2&"
import script from "./tutarbilgileri.vue?vue&type=script&lang=js&"
export * from "./tutarbilgileri.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports